export const GET_ASSESSMENT_LIST = "GET_ASSESSMENT_LIST";
export const GET_ASSESSMENT_SCHEDULE = "GET_ASSESSMENT_SCHEDULE";
export const GET_ASSESSMENT_SLOT = "GET_ASSESSMENT_SLOT";
export const GET_ASSESSMENT_RESULT = "GET_ASSESSMENT_RESULT";
